<div class="row">
  <div class="titleblock">
    <h3 class="title1level">Inserisci nuovo documento</h3>
  </div>
</div>
<div class="row margin-form">
  <form #f="ngForm" [formGroup]="aggiungiDocumentoForm">
    <ng-template [ngIf]="!isFolder">
      <div class="row">
        <div textInput class="col-sm-6" [labelInput]="'Titolo'" [control]="aggiungiDocumentoForm.controls['titolo']"
          formControlName="titolo" [(ngModel)]="formRequest.titolo" [mandatory]="true"></div>
        <div ng-select-combo class="col-sm-6" formControlName="provenienza" [label]="'Provenienza'" [required]="true"
          [options]="tipiProvenienza" [optionSel]="formRequest.provenienza" [disabled]="atto"
          (onChangeSel)="formRequest.provenienza = $event; aggiungiDocumentoForm.controls['provenienza'].setValue($event);">
        </div>
      </div>
      <div class="row">
        <div ng-select-combo class="col-sm-6" formControlName="tipoDocumento" [label]="'Tipo'" [required]="true"
          [options]="tipiDocumento" [optionSel]="formRequest.tipoDocumento" [disabled]="false"
          (onChangeSel)="formRequest.tipoDocumento = $event; aggiungiDocumentoForm.controls['tipoDocumento'].setValue($event);">
        </div>
        <div datePickerInput class="col-sm-6" [labelInput]="'Data riferimento'" formControlName="dataRiferimento"
          [(ngModel)]="formRequest.dataRiferimento" [mandatory]="true"
          [control]="aggiungiDocumentoForm.controls['dataRiferimento']"></div>
      </div>
      <div class="row">
        <div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note" [(ngModel)]="formRequest.note">
        </div>
      </div>

      <div class="" style="float: right;margin-top: 20px">
        <app-upload-tool [standard]="true" (onChange)="onSearchChange($event)"></app-upload-tool>
      </div>

      <div *ngIf="fileUploadList && fileUploadList.length > 0" class="row mx-20 d-flex justify-content-center" >
        <div class="col-sm-12 col-xs-12">
          <table class="tg margin-uploaded">
            <caption class="sr-only">Tabella lista documenti caricati</caption>
            <tr *ngFor="let item of fileUploadList; let index = index">
              <th class="tg-oy1f">
                {{item.nomeFile}}<span style="text-align: center;color:#0b59a4;cursor: pointer; margin-left:5px;" class="glyphicon glyphicon-trash"
                  (click)="deleteFile(fileUploadList.splice(index, 1))"></span>
              </th>
            </tr>
          </table>
        </div>

      </div>
      <div class="row">
        <p class="mandatory col-sm-12">
          <em>* Campi obbligatori</em>
        </p>
      </div>
      <div class="row stepper-border-bottom-mb-15">
        <p class="col-sm-3 col-xs-6">
          <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset();">Annulla</button>
        </p>
        <p submitButton class="col-sm-3 col-sm-offset-6" (click)="save();"
          [labelButton]="'Inserisci documento'"
          [disabled]="!formRequest.titolo || !formRequest.provenienza || !formRequest.tipoDocumento || !formRequest.dataRiferimento || fileUploadList.length === 0">
        </p>
      </div>
    </ng-template>
  </form>
</div>
